import { Channel as StreamChannel, StreamChat } from 'stream-chat';

export const initialiseStreamChannel = async (streamChat: StreamChat, channelId: string): Promise<StreamChannel> => {
  const streamChannel: StreamChannel = streamChat.channel('messaging', channelId);

  await streamChannel.watch();

  return streamChannel;
};
